import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BrandLogo, Button } from '@fluent/ui';
import { LegalLinks } from '../legal/LegalLinks.js';
import { EVERYTHING_FREE } from '../subscription/freeMode.js';
import './auth.css';

/**
 * Welcome — what a signed-out visitor sees at app.fluent.ge/.
 *
 * `/` used to redirect straight to the sign-in form, and Paddle's domain
 * review rejected app.fluent.ge as a "login wall" (2026-09-29): a checkout
 * domain must show what is sold, the price and the legal pages to someone who
 * is not signed in. This page does, in the landing's own words (hero + trial
 * note), and hands off to sign-up or sign-in. Deep links (/learn/…, /profile)
 * still go straight to /login — only the front door changed.
 */
export function Welcome() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <main className="auth-screen">
      <div className="auth-card welcome-card">
        <div className="welcome-card__top">
          <BrandLogo className="auth-card__brand" />
          <img className="welcome-card__mascot" src="/characters/character-10.png" alt="" width={80} height={88} />
        </div>
        <p className="welcome-card__eyebrow">{t('welcome.eyebrow')}</p>
        <h1 className="auth-card__title">{t('welcome.title')}</h1>
        <p className="auth-card__subtitle">{t('welcome.subtitle')}</p>

        <ul className="welcome-card__points">
          <li>{t('welcome.point_lessons')}</li>
          <li>{t('welcome.point_tests')}</li>
          <li>{t('welcome.point_time')}</li>
        </ul>

        <div className="welcome-card__price">
          <p className="welcome-card__price-line">
            {t(EVERYTHING_FREE ? 'welcome.price_free' : 'welcome.price')}
          </p>
          <p className="welcome-card__price-note">
            {t(EVERYTHING_FREE ? 'welcome.price_note_free' : 'welcome.price_note')}
          </p>
        </div>

        <div className="welcome-card__actions">
          <Button variant="primary" size="lg" fullWidth onClick={() => navigate('/signup')}>
            {t('welcome.start')}
          </Button>
          <Button variant="neutral" size="lg" fullWidth onClick={() => navigate('/login')}>
            {t('welcome.have_account')}
          </Button>
        </div>
      </div>
      <div className="auth-screen__legal">
        <LegalLinks />
      </div>
    </main>
  );
}
